import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** Celebration / onboarding. Three balloons in the brand hues. */
export function Balloons(props: IllustrationProps) {
  const string = {
    fill: 'none',
    stroke: sc('fg.subtle'),
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
  };
  return (
    <IllustrationFrame {...props}>
      <path d="M52 86c4 18-8 30 6 52" style={string} />
      <path d="M82 74c-4 22 6 38-2 64" style={string} />
      <path d="M112 90c-6 18 6 28-6 48" style={string} />
      <ellipse cx="52" cy="60" rx="24" ry="28" style={{ fill: c('berry.400') }} />
      <path d="M48 87h8l-4 6z" style={{ fill: c('berry.500') }} />
      <ellipse cx="82" cy="46" rx="26" ry="30" style={{ fill: c('blue.500') }} />
      <path d="M78 75h8l-4 6z" style={{ fill: c('blue.600') }} />
      <ellipse cx="112" cy="64" rx="22" ry="26" style={{ fill: c('gold.400') }} />
      <path d="M108 89h8l-4 6z" style={{ fill: c('gold.500') }} />
      <ellipse
        cx="44"
        cy="50"
        rx="5"
        ry="9"
        transform="rotate(20 44 50)"
        style={{ fill: c('neutral.0'), opacity: 0.45 }}
      />
      <ellipse
        cx="73"
        cy="34"
        rx="5"
        ry="10"
        transform="rotate(20 73 34)"
        style={{ fill: c('neutral.0'), opacity: 0.45 }}
      />
      <ellipse
        cx="105"
        cy="54"
        rx="4"
        ry="8"
        transform="rotate(20 105 54)"
        style={{ fill: c('neutral.0'), opacity: 0.45 }}
      />
    </IllustrationFrame>
  );
}
